/**
 * Taking a machine away (rules 20): the rules' own check of the remove action on the tile, so the
 * button's reason is always theirs (not yours, collect it first), and sending it.
 */
import type { Game } from '../game';
import { actionCheck, submitAction, type ActionCheck } from '../intents/submit';

/** Whether the machine on `tile` can be removed by me now. */
export const removeCheck = (game: Game, tile: number): ActionCheck =>
  actionCheck(game, { kind: 'remove', tile });

/** Remove the machine on `tile`; false, with the rules' refusal, when it can't now. */
export const removeMachine = (game: Game, tile: number): boolean =>
  submitAction(game, { kind: 'remove', tile });
